export default {
  state: {
    priceTypes: [],
    loading: false,
  },
  getters: {
    priceTypes: state => state.priceTypes,
    loading: state => state.loading,
  },
  mutations: {
    setPriceTypes(state, priceTypes) {
      state.priceTypes = priceTypes;
    },
    setLoading(state, display) {
      state.loading = display;
    }
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const priceTypes = await axios.get('api/price-types');
        commit('setPriceTypes', priceTypes);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      try {
        return await axios.get('api/price-types/' + id);
      } catch (e) {
      }
    },

    async add({ commit }, payLoad) {
      await axios.post('api/price-types', payLoad);
    },

    async update({ commit }, payLoad) {
      await axios.put('api/price-types', payLoad);
    },

    async delete({}, id) {
      await axios.delete('api/price-types/' + id);
    }
  },
};
